import { inject, runInInjectionContext } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ScrollToAnchorOptions } from '../types/scroll-to-anchor-options';

export const scrollToAnchor = (factory: () => ScrollToAnchorOptions) => {
  const { injector, anchor, offset = [0, 0] } = factory();
  const viewportScroller = runInInjectionContext(injector, () =>
    inject(ViewportScroller),
  );

  viewportScroller.setOffset(offset);
  viewportScroller.scrollToAnchor(anchor);
};
